import './LiveMap.css';
import '../assets/css/materialdesignicons.css';

import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import Units    from '../tools/Units';
import Services from '../tools/Services';

import MapBtns        from './MapBtns.jsx';
import InfoWindow     from './Airport dialog/InfoWindow';
import AircraftGraph  from './Aircraft dialog/AircraftGraph'
import MapController  from '../GoogleMaps/MapController';
import AirportDialog  from './Airport dialog/AirportDialog';
import AircraftDialog from './Aircraft dialog/AircraftDialog';
import SettingsDialog from './Settings dialog/SettingsDialog';
import ScheduleDialog from './Schedule dialog/ScheduleDialog';


export default class LiveMap extends Component {

    mapController = null;
   
    state = { 
        full:'',
        airport: {},
        aircraft: {},
        airspace: {},
        redirect: false,
        openGraph:false,
        airportOpen: false,
        aircraftOpen: false,
        settingsOpen: false,
        scheduleOpen: false,
        infoWindowOpen: false,
    };

    componentDidMount() {
        // Initialize map
        this.mapController = new MapController();
      
        if(this.mapController) this.setState({map:this.mapController});

        // If no token then redirect to login
        let token = Services.getToken();
        if (token === null ) 
            return this.setState({ redirect: true });

        // Open schedule box
        this.setState({ scheduleOpen: true });

        // Listen for any box opening event
        this.mapEventListener();
        this.settingsListener();
        this.airspaceListener();
        this.airportEventListener();
        this.aircraftEventListener();
    }

    // LISTENERS
    mapEventListener () {
        // Sets Map when Idle
        window.addEventListener('mapListener', (e) => {
            
            // Set Map
            this.setState({map:e.detail})
       
        }, false);
    }

    settingsListener() {

        window.addEventListener('settings', (e) => {
            
            // Open settings
            this.setState({ settingsOpen: true });

            }, false);
    }

    airspaceListener() {
    
        // Listen for airspace event
        window.addEventListener('airspaceClick', (e) => {
            // Close Settings and aircraft
            this.setState({ settingsOpen: false, aircraftOpen: false });
          
            // Open the box
            this.setState({ airspace: e.detail, airportOpen: true });
        });

        // Listen for airspace box open event
        window.addEventListener('airspaceInfoWindowOpen', (e) => {
            this.setState({ infoWindowOpen: true });
        });
    }

    airportEventListener() {
        window.addEventListener('airportClick', (e) => {
            // Close Settings and aircraft
            this.setState({ settingsOpen: false, aircraftOpen: false });

            // Close aircrafts and tracks
            this.handleAircraftClose();

            // Open the airport dialog
            this.setState({ airport: e.detail, airportOpen: true });
        });
    }

    aircraftEventListener() {
        
        // This function is called by cliking on an aircraft or by ScheduleDialog.jsx
        window.addEventListener('aircraft', (e) => {
             
            // Unselect from tracking mode
            this.detachTrackingMode();
         
            // Close every box
            this.setState({ airportOpen: false });
            this.setState({ aircraftOpen: true });
            this.setState({ settingsOpen: false });
            this.setState({ airspaceOpen: false });
            this.setState({ aircraft: e.detail });

            this.centerAircraft(e);

            window.addEventListener('newTrackDrawn', (e) => {
            
                // Quick Fix, will look to just adding 
                // recent tracks later e.detail[0] is the lat and long 
                // to the next position we can look to adding that to the state instead of redrawing
                this.loadChartData(e.detail[1]);
            });

        }, false);

        window.addEventListener('aircraftClick', (e) => {
            
            this.detachTrackingMode();

            this.setState({ airportOpen: false, settingsOpen: false, airspaceOpen: false, aircraft: e.detail, aircraftOpen: true});
            
            this.centerAircraft(e); 

            // Don't load chart detail
            // if aircraft is not in flight
            if (e.detail.inflight) this.loadChartData(e.detail);

        });
        
        //Listen for aircraft updates
        window.addEventListener('UpdateAircraft', (e) => {
            
            // If there is no aircraft set exit 
            if(!this.state.aircraft.id) return;
        
            // Find the aircraft and update it if it is selected
            e.detail.map((update) => {
                if(update.id === this.state.aircraft.id) return this.setState({aircraft : update});
            })
                     
        });

        // Listens for new chart data from aircraft track
        window.addEventListener('newTrackDrawn', (e) => {
            
            // Quick Fix, will look to 
            // just adding recent tracks later 
            // e.detail[0]  is the lat and long to the next position
            // we can look to adding that to the state instead of redrawing
            if (!e.detail[1].inflight) return;
            this.loadChartData(e.detail[1]);
        });
    }

    //LISTENER TOOLS
    centerAircraft = (e) => {
        // map Controller does not exist
        if (!this.mapController) {
            console.error('mapController == undefined');
            return;
        }

        // Center
        this.mapController.map.setCenter({ lat: e.detail.lat, lng: e.detail.lon });

        //Load Graph Data
        this.loadChartData(e.detail, "LoadChartData");
    }
    
    detachTrackingMode = () => {
        // Hide track when you close aircraft dialog
        let ev = new CustomEvent('hideTrack');
        window.dispatchEvent(ev);

        // Stop following
        let dropTracking = new CustomEvent('dropTracking');
        window.dispatchEvent(dropTracking);
    }

    // AIRCRAFT GRAPH 
    loadChartData = async (aircraft) => {
        if(!aircraft.id) return;
        
        // Post
        let id = aircraft.id;
        let res = await Services.post('aircraft2/getTrack', {
            id
        });

        // If bad request, exit
        if (res === undefined)
            return;

        // Error
        if (res.status === 'error'){
            if(aircraft.id !== this.state.aircraft.id) this.setState({openGraph:false});
            this.detachTrackingMode();
            this.setState({points:false})
            return console.log('Aircraft/get error: ' + res.error, res);

        }

        this.setState({res:res.track})
        // Success
        this.sortGraphData(res, aircraft);
    }

    sortGraphData(res, aircraft){
        let data = res.track;
        
        // take out graph data and convest from res.track
        let graphAlt = data.map((r)=> Units.metersToFeet(r.alt));
        let graphElev = data.map((r)=> Units.metersToFeet(r.elev));
        
        // Draw the graph ration with the timestamp
        let graphTimes = data.map((r)=> (r.t));
        let graphSpeeds = data.map((r)=> Units.knotsToKilos(r.s));
    

        //Graph Data and Options for Chart.js
        let points = {
            labels: graphTimes,
            datasets: [
                {
                label: 'Speed',
                data: graphSpeeds,
                fill: false,
                borderDash: [],
                lineTension: 0.1,
                borderDashOffset: 0.0,
                borderColor: '#ffce44',
                borderCapStyle: 'butt',
                borderJoinStyle: 'miter',
                borderWidth: 2,
                backgroundColor: '#e755ba',
                pointRadius: .5,
                pointHitRadius: 10,
                pointBorderWidth: 0,
                pointHoverRadius: 5,
                pointHoverBorderWidth: 2,
                pointBorderColor: '#ffce44',
                pointBackgroundColor: '#ffce44',
                pointHoverBorderColor: '#ffce44',
                pointHoverBackgroundColor: '#ffce44',
                yAxisID: 'y-axis-1',
                },	
                {
                data: graphAlt,
                fill: false,
                label: 'Altitude',
                lineTension: 0,
                borderDash: [],
                borderDashOffset: 0.0,
                borderColor: '#4885ed',
                borderCapStyle: 'butt',
                backgroundColor: '#4885ed',
                borderJoinStyle: 'miter',
                borderWidth: 2,
                pointRadius: .5,
                pointHitRadius: 10,
                pointBorderWidth: 1,
                pointHoverRadius: 5,
                pointHoverBorderWidth: 2,
                pointBorderColor: '#4885ed',
                pointBackgroundColor: '#4885ed',
                pointHoverBorderColor: '#4885ed',
                pointHoverBackgroundColor: '#4885ed',
                yAxisID: 'y-axis-2',
                },
                {
                data: graphElev,  
                fill: true,
                fillOpacity: .3, 
                label: 'Elevation',
                lineTension: 0,
                borderDash: [],
                borderDashOffset: 0.0,
                borderColor: '#1aa260',
                borderCapStyle: 'butt',
                backgroundColor: 'rgba(26, 162, 96, 0.3)',
                borderJoinStyle: 'miter',
                borderWidth: 2,

                pointRadius: .5,
                pointHitRadius: 10,
                pointBorderWidth: .5,
                pointHoverRadius: 5,
                pointHoverBorderWidth: 2,
                pointBorderColor: '#1aa260',
                pointBackgroundColor: '#1aa260',
                pointHoverBorderColor: '#1aa260',
                pointHoverBackgroundColor: '#1aa260',
                yAxisID: 'y-axis-2',
                }
            ]
        };
        
        // Options for dialog graph
        let options = {
            responsive:true,
            hoverMode:'label',
            stacked:false,
            legend:{
                display:true,
                position:'bottom'
            },
            tooltips: {
                backgroundColor: 'rgba(255,255,255, 0.8)',
                titleFontColor: 'rgb(0, 0, 0)',
                bodyFontColor : 'rgb(0, 0, 0)',	
                
                // Tooltip shows all points on hover
                mode: 'index',
                callbacks: {
                    
                    //Add mph and feet to label on tooltips on hover
                    label: function(value) {
                        if(value.datasetIndex === 0) return ` Speed : ${value.value} kts`; 
                        if(value.datasetIndex === 1) return ` Altitude : ${value.value} ft`; 
                        
                        // Return a string that you wish to append
                        return ` Elevation : ${value.value} ft`;  
                    }
                 }
            },
            scales: {
                xAxes: [{
                    type:'time',
                    time: {
                        // Convert time format
                        tooltipFormat:'HH:mm', 
                        displayFormats: {
                           'minute': 'HH:mm',
                           'hour': 'HH:mm',
                        }
                      },
                    ticks:{
                        display: true,
                        autoSkip: true,
                        maxTicksLimit: 4,
                        maxRotation: 0,
                        minRotation: 0,
                        beginAtZero:true
                    },
                    gridLines: {
                        display: false
                    },
                
                    },
                    {
                        position: 'bottom',
                        ticks: {
                            display: false,
                            maxTicksLimit: 5,
                        },
                        gridLines: {
                            display: false,
                            drawTicks: false
                        }
              
                }],
                yAxes: [{
                    // Only linear but allow scale type registration.
                    // This allows extensions to exist solely for log scale for instance.
                    type: 'linear', 
                    display: true,
                    position: 'right',
                    id: 'y-axis-1',
                    
                    ticks: {
                        display: false,
                        autoSkip: true,
                        maxTicksLimit: 4,
                        beginAtZero:true,
                        min:0
                    },
                    gridLines: {
                        // Only want the grid 
                        // lines for one axis to show up
                        display: false, 
                    }, 
                    },{
                    // Only linear but allow scale type registration. 
                    // This allows extensions to exist solely for log scale for instance
                    type: 'linear', 
                    display: true,
                    position: 'left',
                    id: 'y-axis-2',
                    ticks: {
                        display: true,
                        maxTicksLimit: 4,
                        beginAtZero:true,
                        min:0,

                        // Adds ft to Y Axis Label
                        callback: function(value) {
                            return ` ${value} ft`;
                        }
                    },

                    // grid line settings
                    gridLines: {
                        // Only want the grid 
                        // lines for one axis to show up
                        display: true, 
                    },
                }],
                
            }
        };
        
        // Options for pop-out graph
        let popOptions = {
            responsive:true,
            hoverMode:'index',
            stacked:true,
            legend:{
                display:true,
                position:'bottom'
            },
            tooltips: {
                title:false,
                backgroundColor: 'rgba(255,255,255, 0.8)',
                titleFontColor: 'rgb(0, 0, 0)',
                bodyFontColor : 'rgb(0, 0, 0)',	
                // Show all on tooltip
                mode: 'index',
                callbacks: {
                    
                    //Add mph and feet to label on tooltips on hover
                    label: function(value) {
                        if(value.datasetIndex === 0) return ` Speed : ${value.value} kts`; 
                        if(value.datasetIndex === 1) return ` Altitude : ${value.value} ft`; 
                        
                        // return a string that you wish to append
                        return ` Elevation : ${value.value} ft`; 
                    }
                 }
            },
            title: {
                display: false,
                text: aircraft.registration 
            },
            scales: {
                xAxes: [{

                    type:'time',
                    time: {
                        // Convert date format
                        tooltipFormat:'HH:mm', 
                        displayFormats: {
                           'minute': 'HH:mm',
                           'hour': 'HH:mm',
                        }
                      },
                    ticks:{
                        display: true,
                        autoSkip: true,
                        beginAtZero:true,
                        maxRotation: 0,
                        minRotation: 0,
                        maxTicksLimit: 6,
                        
                    },
                    gridLines: {
                        display: false
                    },
                
                    },
                  {
                        position: 'bottom',
                        ticks: {
                            display: false,
                            maxTicksLimit: 5,
                            
                        
                        },
                        gridLines: {
                            display: false,
                            drawTicks: false
                        }
              
                }],
                yAxes: [{
                    // Only linear but allow scale type registration. 
                    // This allows extensions to exist solely for log scale for instance
                    type: 'linear', 
                    display: true,
                    position: 'right',
                    id: 'y-axis-1',
                    ticks: {
                        // Right side Y axis ticks
                        display: true,
                        autoSkip: true,
                        beginAtZero:true,
                        min:0,
                        maxTicksLimit: 4,
                        callback: function(value) {
                            return `${value} kts`;
                        }
                    },
                    gridLines: {
                        // Only want the grid 
                        // lines for one axis to show up.
                        display: false, 
                    }
                }, {
                    type: 'linear', 
                    // Only linear but allow 
                    // scale type registration. This allows 
                    // extensions to exist solely for log scale for instance
                    display: true,
                    position: 'left',
                    id: 'y-axis-2',
                    ticks: {
                        display: true,
                        autoSkip: true,
                        maxTicksLimit: 4,
                        beginAtZero:true,
                        min:0,
                        callback: function(value, index, values) {
                            return `${value} ft`;
                        }
                    },
                    // grid line settings
                    gridLines: {
                        // Only want the grid
                        // lines for one axis to show up
                        display: true, 
                    },
                }],
            }
        };

        // Set the state to pass 
        // the options and data through props
        this.setState({points, options, popOptions});
    }

    // GRAPH TOOLS
    closeGraph = () => {
        this.setState({openGraph:false});
    }
    
    openGraphFromDialog = () => {
        this.setState({openGraph:true});
    }
    
    // HANDLES 
    handlWindowClose = (e) => {
        this.setState({ infoWindowOpen: false });
    }
    
    handleAirportClose = (e) => {
        // Close box
        this.setState({ airportOpen: false });
    }

    handleScheduleOpen = (e) => {
        this.setState({ scheduleOpen: true });
    }

    handleSettingClose = (e) => {
        
        // Close settings and Airspace info box
        this.setState({ settingsOpen: false });
        this.setState({ infoWindowOpen: false });
    
    }

    handleScheduleClose = (e) => {
        this.setState({ scheduleOpen: false });
        this.detachTrackingMode();
    }

    handleAircraftClose = (e) => {
        
        this.setState({ aircraftOpen: false});
        this.setState({ openGraph:false });
        this.setState({aircraft:{}})
 
        // Unselect from tracking mode and hide track
        this.detachTrackingMode();
    }
    
    handleAirspaceClose = (e) => {
        this.setState({ airspaceOpen: false });
    }

    // In mobile menu button toggles
    menuMobileToggle = (e) =>{
        if(this.state.scheduleOpen){
            this.handleScheduleClose();
        }  
        else{
            this.handleScheduleOpen();
        }
    }

    render() {
        let { aircraftOpen, airportOpen, settingsOpen, scheduleOpen, infoWindowOpen, redirect,popOptions, points, options, openGraph} = this.state;
        let map = this.mapController? this.mapController.map : this.state.map;
        
        // Conditional css grid changes to depending 
        // on layers opened starting sidebar and map open
        let mode = 'grid';
        let graphOnly = false;

        // All sidebars & the graph doesnt have data
        if(!aircraftOpen && !airportOpen && !scheduleOpen && !points ) mode = "gridMapOnly";
        if(!aircraftOpen && !airportOpen && !scheduleOpen && !openGraph ) mode = "gridMapOnly";

        // The graph and one of the sidebars is open
        if(points && openGraph && ( aircraftOpen || airportOpen  || scheduleOpen)) mode ='gridGraphAndMap';

        // If only the graph is open no sidebars
        if(points && openGraph && !aircraftOpen && !airportOpen && !scheduleOpen){
            mode ='gridGraphOnly';
            graphOnly = true;
        } 

        return (
            
            <div id="LiveMap" className={mode}>
                {redirect && <Redirect to='/' />}

                <div className="mainLogo"/>

                <MapBtns menuMobileToggle={this.menuMobileToggle} scheduleOpen={scheduleOpen} aircraftOpen={aircraftOpen} airportOpen={airportOpen} handleSchedule={this.handleScheduleOpen} map={map} />
                <InfoWindow open={infoWindowOpen} onClose={this.handlWindowClose} map={this.state.map}/>
            
                <div className="sidebar"> 
                    <ScheduleDialog open={scheduleOpen} onClose={this.handleScheduleClose} map={map}   className='scheduleDialog'   />
                    <SettingsDialog open={settingsOpen} onClose={this.handleSettingClose}  map={map}   className='settingsDialog'   />
                    <AirportDialog  open={airportOpen}  onClose={this.handleAirportClose}  airport={this.state.airport} />
                    <AircraftDialog open={aircraftOpen} onClose={this.handleAircraftClose} className='aircraftDialog' points={points} openGraphFromDialog={this.openGraphFromDialog} aircraft={this.state.aircraft} data={points} options={options} />
                </div>

                <div id="map"></div>
            
                <div id="graphDiv" className="graph">
                        {points && openGraph && <AircraftGraph  class="grid-item" data={points} graphOnly={graphOnly} openGraphFromDialog={this.closeGraph} options={popOptions} openGraph={openGraph} closeGraph={this.handleGraphClose}></AircraftGraph>}
                    </div>

            </div>
        );
    }   
}

